import type { FC } from "react";

import { Button, Icon, Text } from "@alpacahq/ui/old";

import { Card } from "~/v2/components";
import { NewWindowLink } from "~/v2/components/common";

const GOOGLE_COLAB_URL =
  "https://github.com/alpacahq/alpaca-py/tree/master/examples";

type GoogleColabProps = {
  onClose: () => void;
  onClickLink: () => void;
};

export const GoogleColab: FC<GoogleColabProps> = ({ onClose, onClickLink }) => (
  <Card
    className="relative space-y-[0px]"
    tools={
      <Button
        onClick={onClose}
        variant="ghost"
        className="absolute top-1 right-1"
      >
        <Icon name="XMark" size="sm" />
      </Button>
    }
  >
    <Text>
      Start developing with Google Colab,{" "}
      <NewWindowLink to={GOOGLE_COLAB_URL} onClick={onClickLink}>
        try it now
      </NewWindowLink>
    </Text>
  </Card>
);
